<table class="touch-mapping-table">
  <thead>
    <tr class="master-suite-row">
      <th data-testid="source-master-suite-name">Source Master Suite: {{ sourceMasterSuiteName }}</th>
      <th data-testid="destination-master-suite-name">Destination Master Suite: {{ destinationMasterSuiteName }}</th>
    </tr>
    <tr>
      <th>Source Touch</th>
      <th class="destination-header">Destination Touch</th>
    </tr>
  </thead>
  <tbody>
    @for (destinationTouch of destinationTouches; track destinationTouch.id!) {
      <tr data-testid="touch-mapping-row">
        <td class="source-cell">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              data-testid="source-touch-dropdown"
              [panelWidth]="null"
              [value]="sourceForDestination(destinationTouch.id!)"
              (selectionChange)="setSourceForDestination(destinationTouch.id!, $event.value)"
            >
              <mat-option [value]="null">(None — created empty)</mat-option>
              @for (sourceTouch of sourceTouches; track sourceTouch.id) {
                <mat-option [value]="sourceTouch.id">{{ touchLabel(sourceTouch) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
        <td data-testid="destination-touch-label" class="destination-touch-cell">{{ touchLabel(destinationTouch) }}</td>
      </tr>
    }
  </tbody>
</table>

<div class="summary-grid">
  <div class="summary-slot summary-source">
    @if (droppedSourceTouches.length > 0) {
      <div class="summary summary-drop" data-testid="dropped-touches-summary">
        <h4>Source touches to be deleted</h4>
        <ul>
          @for (touch of droppedSourceTouches; track touch.id) {
            <li data-testid="dropped-touch-item">
              {{ touchLabel(touch) }} — {{ shootAssetCount(touch.id!) }} shoot assets · {{ postAssetCount(touch.id!) }} post assets
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div class="summary-slot summary-destination">
    @if (unusedDestinationTouches.length > 0) {
      <div class="summary summary-new" data-testid="unused-destinations-summary">
        <h4>Destination touches without a source</h4>
        <ul>
          @for (touch of unusedDestinationTouches; track touch.id) {
            <li data-testid="unused-destination-item">{{ touchLabel(touch) }}</li>
          }
        </ul>
      </div>
    }
  </div>
</div>
